import { AxiosError } from "axios";

export const isAxiosError = (
  maybeAxiosError: unknown
): maybeAxiosError is AxiosError =>
  typeof maybeAxiosError === "object" &&
  maybeAxiosError !== null &&
  "isAxiosError" in maybeAxiosError &&
  maybeAxiosError.isAxiosError === true;
